import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getMe } from "../api/usersApi";
import toast from "react-hot-toast";
export const useMe = () => {

  const { data: me, isLoading: isLoadingMe } = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
  });

  return {
    me,
    isLoadingMe
  };
};
